<div class="h-20 flex items-center">
  <ng-container *ngIf="sidebarService.$collapsed | async; else fullLogo">
    <app-logo-small [color]="'white'" />
  </ng-container>
  <ng-template #fullLogo>
    <app-logo-full [color]="'white'" />
  </ng-template>
</div>
